"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestTypesValues = void 0;
exports.requestTypesValues = [
    "online",
    "onsite",
    "delivery",
    "analysis",
    "chatAtt",
    "quickPrescription",
    "onDemand",
];
